module.exports = __webpack_public_path__ + "img/bingo_ball-27.81a1a700.png";